import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"ib-app"}},[(_vm.isAuthenticated && _vm.hasCommunity)?_c('div',{staticClass:"ib-layout"},[_c('IBSidebar',{on:{"quit-communities":_vm.goToCommunities}}),_c('div',{staticClass:"ib-content"},[_c('router-view')],1)],1):_c('div',{staticClass:"ib-public"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }